import React, { useEffect, useState } from "react";
import { Button } from "../../../shadcn/components/ui/Button";
import { Input } from "../../../shadcn/components/ui/Input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../shadcn/components/ui/Table";
import { Textarea } from "../../../shadcn/components/ui/Textarea";
import { Calendar } from "../../../shadcn/components/ui/Calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../shadcn/components/ui/Popover";
import { CalendarIcon, Eye, Loader2 } from "lucide-react";
import { format } from "date-fns";
import { cn } from "../../../shadcn/lib/utils";
import { TicketThread } from "../../serviceProvider dashboard/TicketThread";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";

export function HelpAndSupport() {
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [showFilters, setShowFilters] = useState(true);
  const [showSubmitTicket, setShowSubmitTicket] = useState(true);
  const [isTicketThreadOpen, setIsTicketThreadOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [tickets, setTickets] = useState([]); // State for fetched tickets
  const [loading, setLoading] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [loadingTickets, setLoadingTickets] = useState(true);

  const [newTicket, setNewTicket] = useState({
    name: "",
    email: "",
    phone: "",
    description: "",
  });

  <ToastContainer
    position="top-right"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    theme="light"
  />;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTicket((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/ticket/create",
        {
          token: token,
          name: newTicket.name,
          email: newTicket.email,
          phonenumber: newTicket.phone,
          description: newTicket.description,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        console.log("Ticket submitted successfully:", response.data);
        toast.success("Ticket submitted successfully!"); // Success toast
        setNewTicket({ name: "", email: "", phone: "", description: "" });
        fetchTickets(); // Refresh tickets after submission
      } else {
        throw new Error("Failed to submit ticket");
      }
    } catch (error) {
      console.error("Error submitting ticket:", error);
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again."
      ); // Error toast
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  // Fetch tickets from API
  const fetchTickets = async () => {
    setLoadingTickets(true);
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/ticket/get-alltickets",
        {
          token: token,
          dateFrom: dateFrom ? dateFrom.toISOString() : null,
          dateTo: dateTo ? dateTo.toISOString() : null,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        console.log("Tickets fetched:", response.data);
        setTickets(response.data.tickets); // Assuming the response has a tickets array
      } else {
        throw new Error("Failed to fetch tickets");
      }
    } catch (error) {
      console.error("Error fetching tickets:", error);
      toast.error(
        error.response?.data?.message ||
          "An error occurred while fetching tickets."
      );
    } finally {
      setLoadingTickets(false);
    }
  };
  // Fetch tickets on mount. Intentionally mount-only: fetchTickets closes over
  // dateFrom/dateTo, and the filter Apply/Reset handlers already call it directly,
  // so depending on it here would refetch on every calendar click.
  useEffect(() => {
    fetchTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleReset = () => {
    setDateFrom(null);
    setDateTo(null);
  };

  const handleOpenTicketThread = (ticket) => {
    setSelectedTicketId(ticket._id);
    setIsTicketThreadOpen(true);
  };

  const handleCloseTicketThread = () => {
    setSelectedTicketId(null);
    setIsTicketThreadOpen(false);
  };

  // filters
  const handleApplyFilters = () => {
    fetchTickets(); // Re-fetch tickets with new filters
  };

  const handleResetFilters = () => {
    setDateFrom(null);
    setDateTo(null);
    fetchTickets(); // Re-fetch tickets without filters
  };

  return (
    <div className="p-0 lg:p-6 space-y-6 w-[75vw] lg:w-full">
      <div className="flex flex-col md:flex-row gap-6">
        {showFilters && (
          <div className="w-full md:w-1/4 space-y-4 bg-white p-4 rounded-lg border">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-semibold">Filters</h3>
            </div>
            {/* Filters section */}
            <div className="space-y-2 mb-4">
              <h4 className="font-medium">Date Range</h4>
              <div className="grid grid-cols-2 gap-2">
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      className={cn(
                        "w-full justify-start text-left font-normal",
                        !dateFrom && "text-muted-foreground"
                      )}
                    >
                      <CalendarIcon className="h-4 w-4" />
                      {dateFrom ? (
                        format(dateFrom, "PPP")
                      ) : (
                        <span>Date From</span>
                      )}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0 text-wrap">
                    <Calendar
                      mode="single"
                      selected={dateFrom}
                      onSelect={setDateFrom}
                      initialFocus
                    />
                  </PopoverContent>
                </Popover>
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      className={cn(
                        "w-full justify-start text-left font-normal",
                        !dateTo && "text-muted-foreground"
                      )}
                    >
                      <CalendarIcon className="h-4 w-4" />
                      {dateTo ? format(dateTo, "PPP") : <span>Date To</span>}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0">
                    <Calendar
                      mode="single"
                      selected={dateTo}
                      onSelect={setDateTo}
                      initialFocus
                    />
                  </PopoverContent>
                </Popover>
              </div>
              <div className="flex justify-between mt-2">
                <Button variant="outline" onClick={handleResetFilters}>
                  Reset
                </Button>
                <Button
                  className="bg-[#7415e2] hover:bg-purple-600"
                  onClick={handleApplyFilters}
                >
                  Apply
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Tickets section */}
        <div className="flex-1 bg-gray-100 p-4 rounded-lg border">
          <h2 className="text-2xl font-semibold mb-4">Tickets</h2>
          {loadingTickets ? (
            <Loader2 className="animate-spin" />
          ) : (
            <div className="overflow-x-auto">
              <Table className="bg-white">
                <TableHeader className="bg-gray-100">
                  <TableRow>
                    <TableHead>Number</TableHead>
                    <TableHead>Subject</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead>Date Created</TableHead>
                    <TableHead className="text-center">Actions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {tickets.length > 0 ? (
                    tickets.map((ticket) => (
                      <TableRow key={ticket._id}>
                        <TableCell>{ticket.name}</TableCell>
                        <TableCell className="truncate max-w-32">
                          {ticket.description}
                        </TableCell>
                        <TableCell>{ticket.status}</TableCell>
                        <TableCell>
                          {new Date(ticket.createdAt).toLocaleDateString()}
                        </TableCell>
                        <TableCell className="text-center">
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => handleOpenTicketThread(ticket)}
                          >
                            <Eye className="h-4 w-4 mr-2" />
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} className="text-center">
                        No tickets found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </div>
      </div>

      {/* bottom ticket form */}
      {showSubmitTicket && (
        <div className="bg-gray-100 p-4 rounded-lg border">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold">Submit a Ticket</h3>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Name
                </label>
                <Input
                  id="name"
                  name="name"
                  value={newTicket.name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email
                </label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={newTicket.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-700"
                >
                  Phone
                </label>
                <Input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={newTicket.phone}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="description"
                className="block text-sm font-medium text-gray-700"
              >
                Description
              </label>
              <Textarea
                id="description"
                name="description"
                value={newTicket.description}
                onChange={handleInputChange}
                required
              />
            </div>
            <Button type="submit" className="bg-[#7415e2] hover:bg-purple-600">
              {loading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                "Submit"
              )}
            </Button>
          </form>
        </div>
      )}

      {/* Ticket Thread Modal */}
      {isTicketThreadOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black  opacity-50 top-[-2rem]"
            onClick={handleCloseTicketThread}
          ></div>
          <div className="relative z-10 w-full max-w-3xl">
            <TicketThread
              onClose={handleCloseTicketThread}
              ticketId={selectedTicketId}
            />
          </div>
        </div>
      )}
    </div>
  );
}
